import React from "react";
import { Route, HashRouter as Router, Switch } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import { withErrorBoundary } from "./errors";
import { withTranslation } from "react-i18next";
import AppContainer from "./containers/AppContainer";
import LoginContainer from "./containers/LoginContainer";
import PrivateRoute from "./components/PrivateRoute";
import TGlobalMessage from "components/@common/snackbars/TGlobalMessage";

const Root = (props) => {
    React.useEffect(() => {
        document.title = props.t("APP_TITLE");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Router>
            <CssBaseline />
            <TGlobalMessage />
            <Switch>
                <Route
                    path="/login"
                    component={LoginContainer}
                />
                <PrivateRoute
                    path="/"
                    component={AppContainer}
                />
            </Switch>
        </Router>
    );
};

export default withErrorBoundary(withTranslation()(Root));
